import { PopularImages } from "@components/popular-images";
import { CoinsVal } from "@components/icons/coins";
import { ImagesType } from "@features/images/type";
import { useImage } from "@features/images/use-images";
import { Blockquote, Button, Heading, Text } from "@radix-ui/themes";
import { FileInputOrLink } from "@views/app/camera/components/file-input-or-link";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface StudioTryOnProps {
  image: ImagesType;
  onAction: (action: string) => void;
}

export const StudioTryOn = ({ image, onAction }: StudioTryOnProps) => {
  const { t } = useTranslation();
  const [fromImage, setFromImage] = useState<File | string | null>(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const { tryOn } = useImage(image.id);

  const handleApplyTryOn = async () => {
    if (!fromImage) return;

    setIsProcessing(true);
    try {
      await tryOn(fromImage, 1);
      onAction("apply_tryon");
    } catch (error) {
      console.error("Failed to apply try-on:", error);
    }
    setIsProcessing(false);
  };

  return (
    <div className="space-y-4">
      <Heading size="3">{t("studio.try_on.title")}</Heading>

      <div className="space-y-2">
        <FileInputOrLink
          heading={t("studio.try_on.clothing_label")}
          fromImage={fromImage}
          setFromImage={setFromImage}
        />
        <Blockquote size="2">{t("studio.try_on.description")}</Blockquote>
      </div>

      <PopularImages
        type="image_outfit"
        onChange={(item) => setFromImage(item.url)}
      />

      <Button
        size="3"
        className="w-full"
        disabled={!fromImage || isProcessing}
        onClick={handleApplyTryOn}
      >
        <CoinsVal val={8} />
        <Text>{t("studio.try_on.apply")}</Text>
      </Button>
    </div>
  );
};
